
<div class="site-panel" style="border-bottom-style: solid; border-bottom-width: 1px; border-radius: 0; height: 855px;">
    <v-row class="no-frame">
        <v-col class="main-first-col modal-tab no-border ma-0 mr-1">
            <v-row class="no-frame pt-2 w-100">
                <c-recipient-card-iterator
                    class="w-100"
                    title        = "Empfänger des Kunden"
                    :recipients  = "items"
                    :customer-id = "site.customer.id"
                    :lim         = "false"
                    :inc         = "true"
                    :filter      = "this.filter"
                    :enable-zoom ="false"
                    :left-arrow  = "false"
                    :show-main-type-filter="false"
                    :height      = "800"
                    highlight-color="lightgray"
                />
            </v-row>
        </v-col>
        <v-col class="main-middlle-col recipient-col modal-tab no-border ma-0 mr-1">
            <v-row class="no-frame">
                <c-site-recipients-column
                    title           = "Rechnungsempfänger für Anlage"
                    accept-property = "invoice"
                    @assign         = "onAssign"
                    @remove         = "onRemove"
                    :recipients     = "selected.invoice"
                    :separated      = "separated"
                />
            </v-row>
        </v-col>
        <v-col class="main-middlle-col recipient-col modal-tab no-border ma-0 mr-1">
            <v-row class="no-frame">
                <c-site-recipients-column
                    title           = "Leistungsemfänger/Verwender für Anlage"
                    accept-property = "benefit"
                    @assign         = "onAssign"
                    @remove         = "onRemove"
                    :recipients     = "selected.benefit"
                    :separated      = "separated"
                />
            </v-row>
        </v-col>
        <v-col class="main-last-col recipient-col modal-tab no-border ma-0">
            <v-row class="no-frame">
                <div class="w-100 background-aliceblue" >
                </div>
            </v-row>
        </v-col>
    </v-row>
</div>
